import { Flex, Tag } from 'antd';
import { useCallback, useMemo } from 'react';

import type { BottomContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import { PF } from '@pages/Clients/NewClientsList/data/constants';

export const SoldSelected: BottomContentType = ({ id }) => {
  const { filtersMap, onChangeSoldRange } = useNewClientsListContext();

  const { soldRange } = filtersMap.get(id)!;

  const values = useMemo(() => {
    const { from, to } = soldRange;
    return [
      {
        value: from,
        label: `от ${from?.toLocaleString('ru-RU', {
          maximumFractionDigits: 2,
        })}`,
      },
      {
        value: to,
        label: `до ${to?.toLocaleString('ru-RU', {
          maximumFractionDigits: 2,
        })}`,
      },
    ].filter(({ value }) => value !== null);
  }, [soldRange]);

  const onDelete = useCallback(
    (value: number | null) => {
      if (value === soldRange.from) {
        onChangeSoldRange({ from: null, to: soldRange.to }, id);
      } else if (value === soldRange.to) {
        onChangeSoldRange({ from: soldRange.from, to: null }, id);
      }
    },
    [soldRange, onChangeSoldRange, id]
  );

  if (values.length === 0) {
    return null;
  }

  return (
    <Flex className={`${PF}__tags`} wrap="wrap" gap="4px">
      {values.map(({ value, label }) => (
        <Tag
          key={value}
          className={`${PF}__tag`}
          closable
          onClose={() => onDelete(value)}
        >
          {label}
        </Tag>
      ))}
    </Flex>
  );
};
